<template>
    <div class="container-fluid" v-if="team">
        <div class="row">
            <div class="col-12 text-center" style="min-height: 122px;">
                <team-emblem :emblem-id="team.emblemId" size="120"/>
            </div>
            <div class="col-12 text-center">
                <span class="h1">{{team.name}}</span>
            </div>
            <div class="col-12 text-center">
                <span>
                    {{team.coachName}}
                </span>
            </div>
        </div>
        {{ team.id }}
    </div>
</template>

<script>

import TeamEmblem from "@/components/global/TeamEmblem.vue";

export default {
    components: {TeamEmblem},
    props: {
        teamId: String
    },
    data() {
        return {
            team: {}
        }
    },
    watch: {
        teamId: {
            handler(newVal) {
                if (newVal)
                    this.$api.get(`/teams/${newVal}`)
                        .then(res => this.team = res.data)
                        .catch(error => this.handleError(error))
            },
            immediate: true
        }
    }
}
</script>
